export const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const jsonParsePagination = (pagination: string): PaginationType => {
  const parse = JSON.parse(pagination);

  return {
    currentPage: parse.CurrentPage,
    pageSize: parse.PageSize,
    totalPages: parse.TotalPages,
    totalCount: parse.TotalCount,
    hasNext: parse.HasNext,
    hasPrevious: parse.HasPrevious,
  };
  // "{"CurrentPage":1,"TotalPages":5,"PageSize":1,"TotalCount":5,"HasPrevious":false,"HasNext":true}"
};

export function isEmail(email: string) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function numberOnly(value: string) {
  return value.replace(/[^0-9]/g, "");
}
